<template>
  <div class="home">
    <img src="../assets/image/home/banner.jpg" style="width:100%" alt="" />
    <div class="container">
        <br>
      <el-row type="flex" align="middle">
        <el-col :span="12">
          <img src="../assets/image/home/img1.png" style="width:70%" alt="" />
        </el-col>
        <el-col :span="12">
          <h1>什么是<span style="color:#ff462a">生涯规划咨询师</span>？</h1>
          <p class="content">
            生涯规划咨询师是个人学习进步和职业生涯发展的重要导师，可以为学生提供全面、专业的生涯规划服务。生涯规划咨询师项目的目标是帮助学生了解自己的兴趣爱好、优点和潜力，进一步明确自己的职业目标，制定科学的职业规划方案，实现自我发展和职业成长的目标。<br />
            通过生涯规划咨询师项目，可以更加深入地了解自己，了解职业市场和职业发展的趋势和方向，提高职业竞争力和自我发展的潜力。同时，生涯规划咨询师项目也可以帮助来访者在高中时期做好学业规划，更好地为未来的职业发展打下坚实的基础。<br />
            生涯规划咨询师能力评测标准和体系的建设是必不可少的。建立科学的生涯规划咨询师能力评测标准和体系，可以帮助评估咨询师的专业水平，提高咨询师的专业素质和服务质量。这样，来访者在选择生涯规划咨询师时可以更加有针对性和选择性。<br />
            这个职业的核心工作内容是：帮助来访者解决学业和职业上的困惑。
          </p>
        </el-col>
      </el-row>
    </div>
    <br>
    <h1 class=" text-center">
      什么是<span style="color:#ff462a">新高考背景下</span>的生涯规划？
    </h1>
    <p class=" text-center">
      生涯规划包括<span style="color:#ff462a">学业规划</span>和<span
        style="color:#ff462a"
        >职业规划</span
      >两个部分。
    </p>

    <div class="bg">
      <div class="container plan_con">
        <el-row type="flex" align="middle" :gutter="50">
          <el-col :span="12">
            <div class="con_bg1 plan">
              <h2>
                <img src="../assets/image/home/icon1.png" class="icon" alt="">
                学业规划</h2>
              <br>
              <p class="content">
                学业规划是指学生根据自己的兴趣和特长、学业水平、专业性向、生涯发展意向，科学、合理地安排课程修习计划。<br />
                学业规划是生涯规划的主要内容。学业规划的主要目的是指导学生在了解初中和高中课程、学科知识体系、学习要求的差异和自我认知的基础上，更好地适应各个阶段的学习；树立积极的态度，发掘学习潜能，发展学科特长，寻找适合各个阶段和自身特点的学习方法和策略；科学安排各个阶段的修习计划，明确自己的学考、选考意愿；制订参与社团活动、志愿者活动、社会实践、体育锻炼等计划，培养和发展自己的兴趣与特长，处理好学习与生活的关系，科学合理地安排课余时间，养成正确的学习、休息方式。
              </p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="con_bg2 plan">
              <h2 ><img src="../assets/image/home/icon2.png" class="icon" alt="">职业规划</h2>
              <br>
              <p class="content">
                职业规划是指学生对自己未来的生涯发展做出较为全面的设想和计划。学业规划是职业规划的基础，职业规划是学业规划的目标和方向。<br />
                职业规划的主要目的是让学生在了解国内外主要高校的专业信息与社会职业需求、了解专业发展趋向和人才市场需求的前提下，选择合适的发展方向；让学生在选择适合的选修课程和实践活动、了解和体验不同职业的过程中，不断明确学习、成长目标，为专业性发展、职业倾向选择提供判断依据；让学生在了解并掌握升学和就业所需技能的基础上，培养创新精神，树立积极向上的人生态度，努力做对社会有贡献的人。
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="container text-center">
      <br />
      <h1>为什么要成为<span style="color:#ff462a">生涯规划咨询师</span>？</h1>
      <h2>
        <img
          src="../assets/image/home/icon.png"
          alt=""
          height="30"
          class="img"
        />学生目前存在的问题
      </h2>
      <img src="../assets/image/home/img7.png" style="width:100%" alt="" />
    </div>

    <div class="container">
      <br />
      <br />
      <h2>
        <img
          src="../assets/image/home/icon.png"
          alt=""
          height="30"
          class="img"
        />生涯规划咨询师可以做的
      </h2>
   
      <el-card class="card">
        <hr />
        <br>
        <el-row :gutter="50">
          <el-col :span="12">
            <p class="content">
                <ul>
                    <li>每一个人都有自己独特的潜力和价值，而生涯规划正是帮助个体发现并最大化潜力的过程。</li>
                    <li>作为一名生涯规划咨询师，可以与来访者一起探索他们的兴趣、价值观和天赋，帮助他们制定清晰的目标和实现这些目标所需的步骤。</li>
                    <li>可以为他们提供职业市场的信息和职业发展趋势，让他们了解行业内的机会和挑战，并帮助他们做出明智的决策。</li>
                    <li>每个人都应该有机会追求自己的梦想，而生涯规划咨询师可以帮助来访者了解自己的潜力和兴趣，找到最适合自己的职业方向，并在这个过程中提供必要的支持和指导。</li>
                    <li>成为一名生涯规划咨询师能够为年轻人的未来做出积极的贡献。</li>
                </ul>
            </p>
          </el-col>
          <el-col :span="12">
            <img src="../assets/image/home/img3.png" alt="" style="width:100%" />
          </el-col>
        </el-row>
      </el-card>
    </div>

    <br>
    <br>
    <br>

    <div class="module text-center">
        <div class="module_text">
          <h1>生涯规划咨询师<span style="color:#ff462a">5大</span>学习模块</h1>
        <p style="color:#666666;font-size:14px;">生涯规划咨询师课程的分为5个板块学习</p>
        </div>
     <br>
     <br>
     <br>
     <br>
        <img src="../assets/image/home/img9.png" alt="" style="width:60%;">
    </div>

    <div class="container">
        <br>
        <h1 class="text-center">生涯规划咨询师<span style="color:#ff462a">适合人群</span></h1>
        <br>
        <div class="box" >
            <div class="item" v-for="item in list" :key="item.id">
                <el-row type="flex" justify="space-around" align="middle">
                    <el-col :span="12">
                        <img :src="item.url" alt="" style="width:80%">
                    </el-col>
                    <el-col :span="12">
                        <h2>{{item.title}}</h2>
                        <br>
                        <p class="content">{{item.bottom}}</p>
                    </el-col>
                </el-row>
            </div>
          
        </div>
    </div>

  </div>
</template>

<script setup>
export default {
  name: 'addhome',
  data() {
    return {
      list: [
           {url:require('../assets/image/home/img2.png'),title:'高校、中学老师',bottom:'帮助学生进行学业和职业规划，解决学生成长性难题',id:0},
           {url:require('../assets/image/home/img5.png'),title:'想成为生涯规划咨询师的人士',bottom:'掌握整套生涯规划的流程和方法，具备提供咨询服务的能力。',id:1},
           {url:require('../assets/image/home/img4.png'),title:'教培机构从业者',bottom:'系统学习生涯理论知识，帮助业务转型或业务开拓。',id:2},
           {url:require('../assets/image/home/img6.png'),title:'金融、保险行业从业者',bottom:'掌握来访者常见问题的解决方案和思路，运用专业工具达成咨询目标。',id:3,},
      ],
    
    }
  },
  created() {
    if(this.$route.query.id){
      localStorage.setItem('agent_id',this.$route.query.id)
    }
  },
  methods: {
   
  },
}
</script>

<style lang="less" scoped>
.home {
  min-width: 1100px;

}

.container {
  min-width: 1100px;
//   margin: 20px 20%;
  width: 60%; 
  margin: 0 auto;
}
.img {
  vertical-align: middle;
}
h1 {
  font-size: 28px;
  margin: 15px 0;
}
.content {
  color: #666666;
  font-size: 14px;
  line-height: 26px;
}
.bg {
  height: 300px;
  background: url('../assets/image/home/bg1.png');
  background-size: 100% 100%;
  position: relative;
  margin-top: 200px;
}
.con_bg1 {
  height: 300px;
  background: url('../assets/image/home/bg4.png');
}
.con_bg2 {
  height: 300px;
  background: url('../assets/image/home/bg5.png');
}
.plan {
  padding: 50px;
}
.plan_con {
  position: absolute;
  top: -140px;
  left: 50%;
  transform: translate(-50%);
}
hr {
  background-color: #ffe9e5;
  height: 5px;
  border: none;
}
.card {
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: none;
  padding:0 20px 20px 20px;
}
.module{
  height: 20%;
  background: url('../assets/image/home/bg3.png');
  background-size: 100% 100%;
  padding:10px 50px 50px 50px;
  position: relative;

}
.module_text{
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translate(-50%);
}
.box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
}
 .item {
     flex: 1;
     border: 1px solid #FD7150;
     border-radius: 8px;
     margin: 20px ;
     padding: 20px;
     min-width: calc((100% - 170px) / 2);
 
 }
 .icon{
  vertical-align: middle;
 }
</style>
